import React, { useEffect, useState } from "react";
import Breadcrumb from "../../../../layouts/full-layout/breadcrumb/Breadcrumb";
import FeatherIcon from "feather-icons-react";
import {
    ChangeQuestionStatus,
  GetAllQuestions,
} from "../../../../services/human-resource";
import PropTypes from "prop-types";
import { useTheme } from "@mui/material/styles";
import FirstPageIcon from "@mui/icons-material/FirstPage";
import KeyboardArrowLeft from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRight from "@mui/icons-material/KeyboardArrowRight";
import LastPageIcon from "@mui/icons-material/LastPage";
import {
  Card,
  CardContent,
  TableHead,
  Grid,
  Box,
  Table,
  TableBody,
  TableCell,
  TablePagination,
  TableRow,
  TableFooter,
  IconButton,
  TableSortLabel,
  TableContainer,
  Paper,
  Tooltip,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  MenuItem,
  Switch,
} from "@mui/material";
import CustomTextField from "../../../../components/forms/custom-elements/CustomTextField";
import RemoveRedEyeOutlinedIcon from "@mui/icons-material/RemoveRedEyeOutlined";
import { routes } from "../../../../routes/routes";
import { useNavigate } from "react-router";
import DeleteIcon from "@mui/icons-material/Delete";
import { toast } from "react-toastify";
import swal from "sweetalert";
import { DeleteVisitorById, DownloadVisitorPdf, GetAllVisitors } from "../../../../services/attendance-change";
import { Print } from "@mui/icons-material";
import CustomSelect from "../../../../components/forms/custom-elements/CustomSelect";
import { DatePicker, LocalizationProvider } from "@mui/lab";
import AdapterDateFns from "@mui/lab/AdapterDateFns";
import { GetUserDetail } from "../../../../services/user";

const BCrumb = [
  {
    to: "/",
    title: "Attendance",
  },
  {
    title: "All Visitors",
  },
];

function TablePaginationActions(props) {
  const theme = useTheme();
  const { count, page, rowsPerPage, onPageChange } = props;

  const handleFirstPageButtonClick = (event) => {
    onPageChange(event, 0);
  };

  const handleBackButtonClick = (event) => {
    onPageChange(event, page - 1);
  };

  const handleNextButtonClick = (event) => {
    onPageChange(event, page + 1);
  };

  const handleLastPageButtonClick = (event) => {
    onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
  };

  return (
    <Box sx={{ flexShrink: 0, ml: 2.5 }}>
      <IconButton
        onClick={handleFirstPageButtonClick}
        disabled={page === 0}
        aria-label="first page"
      >
        {theme.direction === "rtl" ? <LastPageIcon /> : <FirstPageIcon />}
      </IconButton>
      <IconButton
        onClick={handleBackButtonClick}
        disabled={page === 0}
        aria-label="previous page"
      >
        {theme.direction === "rtl" ? (
          <KeyboardArrowRight />
        ) : (
          <KeyboardArrowLeft />
        )}
      </IconButton>
      <IconButton
        onClick={handleNextButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="next page"
      >
        {theme.direction === "rtl" ? (
          <KeyboardArrowLeft />
        ) : (
          <KeyboardArrowRight />
        )}
      </IconButton>
      <IconButton
        onClick={handleLastPageButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="last page"
      >
        {theme.direction === "rtl" ? <FirstPageIcon /> : <LastPageIcon />}
      </IconButton>
    </Box>
  );
}

TablePaginationActions.propTypes = {
  count: PropTypes.number.isRequired,
  onPageChange: PropTypes.func.isRequired,
  page: PropTypes.number.isRequired,
  rowsPerPage: PropTypes.number.isRequired,
};

export const AllVisitors = () => {
  const [visitors, setVisitors] = useState([]);
  const [filter,setFiltered]= useState([]);
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [approvalStatus, setApprovalStatus] = useState("");
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [orderDirection, setOrderDirection] = useState("desc");
  const [valueToOrderBy, setValueToOrderBy] = useState("Id");
  const [totalRecords, setTotalRecords] = useState();
  const [searchValue, setSearchValue] = useState("");
  const [open, setOpen] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedId, setSelectedId] = useState(null);
  const [userid, setuserid] = useState(null);

  const navigate = useNavigate();
 
   const getUserDetail = async () => {
     try {
       const response = await GetUserDetail();
      setuserid(response?.data?.personId);
       console.log("  userObj",userid);
     } catch (e) {}
   };
   getUserDetail();
  useEffect(() => {
    getvisitors();
  }, [rowsPerPage, searchValue, valueToOrderBy, orderDirection, page]);

  const getvisitors = async () => {
    const start = rowsPerPage * page;
    const length = rowsPerPage;
    const sortValue = `${valueToOrderBy} ${orderDirection}`;
    const searchKeyword = searchValue ? searchValue : null;
    const data = {
      start: start,
      length: length,
      sortExpression: sortValue,
      searchKeyword: searchKeyword,
    };
    try {
      const response = await GetAllVisitors(data);
      if (response?.status === 200) {
        
        const formattedData = response.data.result.map(visitor => ({
          ...visitor,
          validUpto: visitor.validUpto.split(' ')[0] ,
          visitingDate: visitor.visitingDate.split(' ')[0]
                }));
        setVisitors(formattedData);
 
        setFiltered(formattedData);
        // setVisitors(response?.data?.result);
        setTotalRecords(response?.data?.totalRecords);
      }
    } catch (e) {
      console.log(e);
    }
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

const handleSearch = () => {
  let filtered = [...filter];
   if (searchValue) {
    const keyword = searchValue.toLowerCase();
    filtered = filtered.filter((v) =>
      (v.initiatorName?.toLowerCase()?.includes(keyword) ||
       v.department?.toLowerCase()?.includes(keyword) ||
       v.visitingPersonName?.toLowerCase()?.includes(keyword) ||
       v.purpose?.toLowerCase()?.includes(keyword) ||
       v.contactNo?.toLowerCase()?.includes(keyword))
    );
  }
  if (fromDate) {
    const from = new Date(fromDate);
    filtered = filtered.filter((v) => {
      const [dd, mm, yyyy] = v.visitingDate.split("-");
      const visitDate = new Date(`${yyyy}-${mm}-${dd}`);
      return visitDate >= from;
    });
  }

  if (toDate) {
   const to = new Date(toDate);
    filtered = filtered.filter((v) => {
      const [dd, mm, yyyy] = v.visitingDate.split("-");
      const visitDate = new Date(`${yyyy}-${mm}-${dd}`);
      return visitDate <= to;
    });
  }

  if (approvalStatus && approvalStatus !== "All") {
  filtered = filtered.filter((v) => v.approval === approvalStatus);
}
  setVisitors(filtered);
  setTotalRecords(filtered.length);
};

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handlRequestSort = (property) => {
    const isAscending = valueToOrderBy === property && orderDirection === "asc";
    setValueToOrderBy(property);
    setOrderDirection(isAscending ? "desc" : "asc");
  };

  const handleChangeSwitch = (status, id) => {
    swal({
      title: "Confirmation",
      text: "Do you want to change the status?",
      icon: "warning",
      buttons: ["Cancel", "OK"],
      dangerMode: true,
    }).then((confirmed) => {
      if (confirmed) {
        handleConfirmDelete(status, id);
      }
    });
  };

  const handleDeleteClick = (row) => {
    setSelectedRow(row); 
    setOpen(true); 
  };

  const handleClose = () => {
    setOpen(false); 
    setSelectedRow(null); 
  };

  const handleConfirmDelete = async () => {
    try {
      if (selectedRow) {
        const response = await DeleteVisitorById(selectedRow.id); 
        if (response?.status === 200) {
          toast.success("Visitor deleted successfully!");
          getvisitors(); 
        }
      }
    } catch (error) {
      console.error(error);
      toast.error("Failed to delete the visitor.");
    } finally {
      handleClose(); // Close the modal
    }
  };

  const handlePrint = async (id) => {
    const response = await DownloadVisitorPdf(id,1);
    if (response?.status === 200) {
      var base64Str = response?.data;
      var binaryString = window.atob(base64Str);
      var binaryLen = binaryString.length;
      var bytes = new Uint8Array(binaryLen);
      for (var i = 0; i < binaryLen; i++) {
        var ascii = binaryString.charCodeAt(i);
        bytes[i] = ascii;
      }
      var arrBuffer = bytes;
      var newBlob = new Blob([arrBuffer], { type: "application/pdf" });

      var data = window.URL.createObjectURL(newBlob);
      window.open(data, "_blank");
    }
  };
  const handleDownload = async (id,type) => {
    try {
      const response = await DownloadVisitorPdf(id,type);
      if (response?.status === 200) {
        const base64Str = response?.data;
        const binaryString = window.atob(base64Str);
        const binaryLen = binaryString.length;
        const bytes = new Uint8Array(binaryLen);
        for (let i = 0; i < binaryLen; i++) {
          const ascii = binaryString.charCodeAt(i);
          bytes[i] = ascii;
        }
        const arrBuffer = bytes;
        const newBlob = new Blob([arrBuffer], { type: "application/pdf" });
  
        // Create a download link
        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(newBlob);
        link.download = `Visitor_${id}.pdf`; // Set the file name
        link.click(); // Trigger the download
        setModalOpen(false);
      }
    } catch (error) {
      console.error("Failed to download the file:", error);
      toast.error("Failed to download the file.");
    }
  };
  return (
    <>
      <Breadcrumb title="All Visitors" items={BCrumb} />
      
      <Card sx={{ p: 0 }}>
        <Box
          display="flex"
          alignItems="center"
          p={2}
          sx={{
            backgroundColor: "primary.light",
            color: "primary.main",
          }}
        >
          <FeatherIcon icon="alert-circle" width="18" />
          <Box sx={{ ml: 1 }}>All Visitors</Box>
          <Button
                    variant="contained"
                    color="primary"
                    onClick={()=>navigate(routes.addvisitor.match)}
                    sx={{ ml: "auto" }}
                  >
                    Add Visitor
                  </Button>
        </Box>
        <CardContent>
          <Grid container spacing={3}>
            <Grid item lg={3} md={3} sm={12} mt={3}>
              <CustomTextField
                id="search"
                placeholder="Search Visitor..."
                size="small"
                type="search"
                variant="outlined"
                fullWidth
                onChange={(e) => {
                  setSearchValue(e.target.value);
                  setPage(0);
                }}
              />
            </Grid>
            <Grid item lg={3} md={3} sm={12}>
              Approval
                <CustomSelect
                  id="approval-status"
                  value={approvalStatus}
                  fullWidth
                  variant="outlined"
                  size="small"
                  onChange={(e) => setApprovalStatus(e.target.value)}
                >
                  <MenuItem value="All">All</MenuItem>
                  <MenuItem value="Approved">Approved</MenuItem>
                  <MenuItem value="Pending">Pending</MenuItem>
                  <MenuItem value="Denied">Denied</MenuItem>
                </CustomSelect>
            </Grid>
              <Grid item lg={3} md={3} sm={12}>
                FromDate
                <LocalizationProvider dateAdapter={AdapterDateFns}>
                  <DatePicker
                    
                    value={fromDate}
                    onChange={(newValue) => setFromDate(newValue)}
                    renderInput={(params) => (
                      <CustomTextField
                        {...params}
                        size="small"
                        fullWidth
                        name="fromDate"
                        variant="outlined"
                      />
                    )}
                  />
                </LocalizationProvider>
              </Grid>
                    <Grid item lg={3} md={3} sm={12}>
                ToDate
                <LocalizationProvider dateAdapter={AdapterDateFns}>
                  <DatePicker
                    
                    value={toDate}
                    onChange={(newValue) => setToDate(newValue)}
                    renderInput={(params) => (
                      <CustomTextField
                        {...params}
                        size="small"
                        fullWidth
                        name="fromDate"
                        variant="outlined"
                      />
                    )}
                  />
                </LocalizationProvider>
              </Grid>
          </Grid>

          <Grid container spacing={3}>
            <Grid item lg={3} md={3} sm={12} mt={3}>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={handleSearch}
                >
                  Search

                </Button>
            </Grid>
          </Grid>
        </CardContent>
        <CardContent>
          <Grid item lg={12} md={12} sm={12} style={{ overflow: "auto" }}>
            <TableContainer
              component={Paper}
              sx={{ maxHeight: 450, overflow: "auto" }}
            >
              <Table
                aria-label="custom pagination table"
                stickyHeader
                sx={{ whiteSpace: "nowrap" }}
              >
                <TableHead sx={{ position: "sticky", top: 0, zIndex: 1 }}>
                  <TableRow>
                    <TableCell>
                      <TableSortLabel
                        active={valueToOrderBy === "initiatorName"}
                        direction={
                          valueToOrderBy === "initiatorName" ? orderDirection : "desc"
                        }
                        onClick={() => handlRequestSort("initiatorName")}
                      >
                        Initiator Name
                      </TableSortLabel>
                    </TableCell>
                    {/* <TableCell>
                      <TableSortLabel
                        active={valueToOrderBy === "department"}
                        direction={
                          valueToOrderBy === "department"
                            ? orderDirection
                            : "desc"
                        }
                        onClick={() => handlRequestSort("department")}
                      >
                        Department
                      </TableSortLabel>
                    </TableCell> */}
                    <TableCell>
                      {/* <TableSortLabel
                        active={valueToOrderBy === "visitingPersonName"}
                        direction={
                          valueToOrderBy === "visitingPersonName"
                            ? orderDirection
                            : "desc"
                        }
                        onClick={() => handlRequestSort("visitingPersonName")}
                      > */}
                        Visiting Person Name
                      {/* </TableSortLabel> */}
                    </TableCell>
                    <TableCell>
                      <TableSortLabel
                        active={valueToOrderBy === "visitingDate"}
                        direction={
                          valueToOrderBy === "visitingDate"
                            ? orderDirection
                            : "desc"
                        }
                        onClick={() => handlRequestSort("visitingDate")}
                      >
                        Visiting Date
                      </TableSortLabel>
                    </TableCell>
                    <TableCell>
                      {/* <TableSortLabel
                        active={valueToOrderBy === "visitingTime"}
                        direction={
                          valueToOrderBy === "visitingTime"
                            ? orderDirection
                            : "desc"
                        }
                        onClick={() => handlRequestSort("visitingTime")}
                      > */}
                        Visiting Time
                      {/* </TableSortLabel> */}
                    </TableCell>
                    <TableCell>
                      {/* <TableSortLabel
                        active={valueToOrderBy === "visitingType"}
                        direction={
                          valueToOrderBy === "visitingType"
                            ? orderDirection
                            : "desc"
                        }
                        onClick={() => handlRequestSort("visitingType")}
                      > */}
                        Visiting Type
                      {/* </TableSortLabel> */}
                    </TableCell>
                    <TableCell>
                      {/* <TableSortLabel
                        active={valueToOrderBy === "purpose"}
                        direction={
                          valueToOrderBy === "purpose"
                            ? orderDirection
                            : "desc"
                        }
                        onClick={() => handlRequestSort("purpose")}
                      > */}
                        Purpose
                      {/* </TableSortLabel> */}
                    </TableCell>
                    <TableCell>
                      {/* <TableSortLabel
                        active={valueToOrderBy === "validUpto"}
                        direction={
                          valueToOrderBy === "validUpto"
                            ? orderDirection
                            : "desc"
                        }
                        onClick={() => handlRequestSort("validUpto")}
                      > */}
                        Valid Upto
                      {/* </TableSortLabel> */}
                    </TableCell>
                    <TableCell>
                      {/* <TableSortLabel
                        active={valueToOrderBy === "representing"}
                        direction={
                          valueToOrderBy === "representing"
                            ? orderDirection
                            : "desc"
                        }
                        onClick={() => handlRequestSort("representing")}
                      > */}
                        Representing  
                      {/* </TableSortLabel> */}
                    </TableCell>
                    {/* <TableCell> */}
                      {/* <TableSortLabel
                        active={valueToOrderBy === "contactNo"}
                        direction={
                          valueToOrderBy === "contactNo"
                            ? orderDirection
                            : "desc"
                        }
                        onClick={() => handlRequestSort("contactNo")}
                      > */}
                        {/* Contact No   */}
                      {/* </TableSortLabel> */}
                    {/* </TableCell> */}
                    <TableCell>
                      {/* <TableSortLabel
                        active={valueToOrderBy === "contactNo"}
                        direction={
                          valueToOrderBy === "contactNo"
                            ? orderDirection
                            : "desc"
                        }
                        onClick={() => handlRequestSort("contactNo")}
                      > */}
                        Approval Status  
                      {/* </TableSortLabel> */}
                    </TableCell>
                    <TableCell>
                      Select Type
                    </TableCell>
                     <TableCell>
                      Location
                    </TableCell>
                    <TableCell>Action</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {visitors?.map((rows) => (
                    <TableRow key={rows?.id}>
                      <TableCell
                        sx={{
                          whiteSpace: "normal",
                          wordWrap: "break-word",
                          maxWidth: 300,
                        }}
                      >
                        {rows?.initiatorName ? rows?.initiatorName : rows?.hostPersonToMeet}
                      </TableCell>
                      {/* <TableCell sx={{ maxWidth: 100 ,wordWrap: "break-word",whiteSpace: "normal"}}>
                        {rows?.department}
                      </TableCell> */}
                      <TableCell  sx={{
                          whiteSpace: "normal",
                          wordWrap: "break-word",
                          maxWidth: 300,
                        }}>
                        {rows?.visitingPersonName}
                      </TableCell>   <TableCell sx={{ maxWidth: 100 }}>
                        {rows?.visitingDate}
                      </TableCell>   <TableCell sx={{ maxWidth: 100 }}>
                        {rows?.visitingTime}
                      </TableCell>   
                      <TableCell sx={{ maxWidth: 100 }}>
                        {rows?.visitingType}
                      </TableCell>
                      <TableCell sx={{
                          whiteSpace: "normal",
                          wordWrap: "break-word",
                          maxWidth: 300,
                        }}>
                        {rows?.purpose}
                      </TableCell>
                      <TableCell sx={{ maxWidth: 100 }}>
                        {rows?.validUpto}
                      </TableCell>
                      <TableCell sx={{ maxWidth: 100, whiteSpace: "normal",
                          wordWrap: "break-word", }}>
                        {rows?.representing}
                      </TableCell>
                      {/* <TableCell sx={{ maxWidth: 100 }}>
                        {rows?.contactNo}
                      </TableCell> */}
                      <TableCell sx={{ maxWidth: 100 }}>
                        {rows?.approval}
                      </TableCell>
                      <TableCell sx={{ maxWidth: 100 }}>
                        {rows?.selectType}
                      </TableCell>
                      <TableCell sx={{ maxWidth: 100 }}>
                        {rows?.location}
                      </TableCell>
                      <TableCell>
                        {userid == rows?.visitorID ? (
                        <Tooltip title="Edit" placement="left-start">
                          <IconButton
                            size="small"
                            onClick={() =>
                              navigate(
                                routes?.editVisitor.build(`${rows.id}`, {
                                  id: `${rows?.id}`,
                                })
                              )
                            }
                          >
                            <FeatherIcon icon="edit-2" width="16" />
                          </IconButton>
                        </Tooltip>) : null}
                        &nbsp;
                        <Tooltip title="View" placement="top">
                          <IconButton
                            size="small"
                            onClick={() =>
                              navigate(
                                routes?.visitorView.build(`${rows.id}`, {
                                  id: `${rows?.id}`,
                                })
                              )
                            }
                          >
                            <RemoveRedEyeOutlinedIcon width="16" />
                          </IconButton>
                        </Tooltip>
                        &nbsp;
                        
                       
                        {/* <Tooltip title="Delete" placement="top">
                          <IconButton
                            size="small"
                            onClick={() => handleDeleteClick(rows)} // Open the modal on click
                          >
                            <DeleteIcon color="error" />
                          </IconButton>
                        </Tooltip> */}
                        <IconButton onClick={() => handlePrint(rows?.id)}>
                                                <Print />
                                              </IconButton>
                        <Tooltip title="Download" placement="top">
                          <IconButton onClick={() => {setSelectedId(rows?.id);setModalOpen(true);}}>
                          <FeatherIcon icon="download" width="16" />
                          </IconButton>
                        </Tooltip>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
                <TableFooter>
                  <TableRow></TableRow>
                </TableFooter>
              </Table>
            </TableContainer>
            <Dialog open={open} onClose={handleClose}>
              <DialogTitle>Confirm Deletion</DialogTitle>
              <DialogContent>
                Are you sure you want to delete this visitor?
              </DialogContent>
              <DialogActions>
                <Button onClick={handleClose} color="primary">
                  Cancel
                </Button>
                <Button onClick={handleConfirmDelete} color="error">
                  Delete
                </Button>
              </DialogActions>
            </Dialog>
            <Dialog open={modalOpen} onClose={() => setModalOpen(false)}>
              <DialogTitle>Select Language</DialogTitle>
              <DialogContent>
                Which language do you want to download the file in?
              </DialogContent>
              <DialogActions>
                <Button
                  onClick={() => handleDownload(selectedId, 1)}
                  color="primary"
                >
                  English
                </Button>
                <Button
                  onClick={() => handleDownload(selectedId, 2)}
                  color="primary"
                >
                  Gujarati
                </Button>
                <Button onClick={() => setModalOpen(false)} color="primary">
                  Close
                </Button>
              </DialogActions>
            </Dialog>
          </Grid>
          <Box style={{ display: "flex", justifyContent: "flex-end" }}>
            <TablePagination
              rowsPerPageOptions={[
                5,
                10,
                25,
                { label: "All", value: totalRecords },
              ]}
              colSpan={10}
              count={totalRecords || 0}
              rowsPerPage={rowsPerPage}
              page={page}
              SelectProps={{
                inputprops: { "aria-label": "rows per page" },
                native: true,
              }}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
              ActionsComponent={TablePaginationActions}
            />
          </Box>
        </CardContent>
      </Card>
    </>
  );
};